import { render, staticRenderFns } from "./HotelStatisticsTable.vue?vue&type=template&id=05706bf6"
import script from "./HotelStatisticsTable.vue?vue&type=script&lang=js"
export * from "./HotelStatisticsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports